import cx from 'classnames';
import PropTypes from 'prop-types';
import { useFocused, useSelected } from 'slate-react';

import { IS_MAC_OS } from 'src/lib/userAgent';

import { useStyles } from './useStyles';

export const InstructionNode = ({ element, children, attributes }) => {
  const styles = useStyles();

  const selected = useSelected();
  const focused = useFocused();

  return (
    <span
      className={cx(styles.root, {
        [styles.highlighted]: selected && focused,
      })}
      {...attributes}
      data-node-type={element.type}
      contentEditable={false}
    >
      {/* Prevent Chromium from interrupting IME when moving the cursor */}
      {/* 1. span + inline-block 2. div + contenteditable=false */}
      <div contentEditable={false}>
        {IS_MAC_OS ? (
          // Mac OS IME https://github.com/ianstormtaylor/slate/issues/3490
          <>
            {children}
            {element.children[0].text}
          </>
        ) : (
          // Others like Android https://github.com/ianstormtaylor/slate/pull/5360
          <>
            {element.children[0].text}
            {children}
          </>
        )}
      </div>
    </span>
  );
};

InstructionNode.propTypes = {
  attributes: PropTypes.shape({}),
  element: PropTypes.shape().isRequired,
  children: PropTypes.node,
};

InstructionNode.defaultProps = {
  attributes: {},
  children: null,
};
